<template>
  <div class="txn-wrap">
    <div id="realChart" class="line-chart"></div>
  </div>
</template>

<script>
let echarts = require('echarts')
import themeVarsDefine from '@/mixins/themeVarsDefine';
import adaptation from '@/mixins/adaptation';
export default {
  name: 'TxnLine',
  mixins: [themeVarsDefine, adaptation],
  themeVarsDefine: {
    dark: {
      xAxisAxisLabelColor: '#78B3CD',
      yAxisAxisLabelColor: '#78B3CD',
      yAxisSplitLineColor: '#33406D',
      seriesLineColor: '#1CBCFF',
      seriesAreaStartColor: '#5AA4CB',
      seriesAreaEndColor: 'rgba(48, 111, 255, 0.00)',
      tooltipBorderColor: '#303C65',
      tooltipBackgroundColor: '#112245',
      tooltipTextColor: '#FFF',
      tooltipAxisLineColor: '#fff',
      tooltipSymbolColor: '#fff'
    },
    default: {
      xAxisAxisLabelColor: '#5A6973',
      yAxisAxisLabelColor: '#5A6973',
      yAxisSplitLineColor: '#F9F9F9',
      seriesLineColor: '#1CBCFF',
      seriesAreaStartColor: '#45C2FF',
      seriesAreaEndColor: 'rgba(255, 255, 255, 0.00)',
      tooltipBorderColor: '#F9F9F9',
      tooltipBackgroundColor: '#fff',
      tooltipTextColor: '#122836',
      tooltipAxisLineColor: '#122836',
      tooltipSymbolColor: '#1CBCFF'
    }
  },
  adaptationVarsDefine: {
    axisLabelFontSize: 10,
    yAxisSplitLineWidth: 1,
    seriesLineWidth: 1,
    tooltipBorderWidth: 1,
    tooltipPadding: 16,
    tooltipFontSize: 12,
    tooltipBorderRadius: 2,
    tooltipAxisLineWidth: 1,
    seriesSymbolSize: 2
  },
  data() {
    return {
      chart: null,
      option: {
        tooltip: {
          show: true,
          trigger: 'axis',
          borderColor: '#303C65',
          borderWidth: 1,
          backgroundColor: '#112245',
          padding: 16,
          formatter: function (item) {
            let data = item[0].value
            let time = item[0].axisValue
            return time + '</br>' + '交易量：' + `<span style="color:#6DD4FF;">${data}</span>`
          },
          textStyle: {
            color: '#fff',
            fontWeight: 400,
            fontSize: 12,
            fontStyle: 'normal',
            lineHeight: 'normal'
          },
          extraCssText: 'border-radius: 2px;',
          axisPointer: {
            lineStyle: {
              color: '#FFF',
              width: 1
            }
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: '#78B3CD',
              fontSize: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: ''
            }
          },
          interval: 0,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          boundaryGap: ['4.5%', '2.7%']
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#78B3CD',
              fontSize: 10
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#33406D',
              width: 1,
            }
          },
          axisLine: {
            lineStyle: {
              color: ''
            }
          },
          axisTick: {
            show: false
          },
          splitNumber: 5
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 2,
            showSymbol: false,
            itemStyle: {
              color: 'transparent',
              borderColor: '#fff'
            },
            lineStyle: {
              width: 1,
              color: '#1CBCFF'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5AA4CB'
                },
                {
                  offset: 1,
                  color: 'rgba(48, 111, 255, 0.00)'
                }
              ])
            }
          }
        ],
        grid: {
          left: '4.45%',
          top: '17.8%',
          right: '1.93%',
          bottom: '21.1%',
        },
        backgroundColor: ''
      }
    }
  },
  watch: {
    themeVars: function (val) {
      this.chart.setOption({
        tooltip: {
          borderColor: val.tooltipBorderColor,
          backgroundColor: val.tooltipBackgroundColor,
          textStyle: {
            color: val.tooltipTextColor,
          },
          axisPointer: {
            lineStyle: {
              color: val.tooltipAxisLineColor
            }
          }
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              color: val.xAxisAxisLabelColor
            }
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: val.yAxisAxisLabelColor
            }
          },
          splitLine: {
            lineStyle: {
              color: val.yAxisSplitLineColor
            }
          }
        },
        series: [{
          itemStyle: {
            borderColor: val.tooltipSymbolColor
          },
          lineStyle: {
            color: val.seriesLineColor
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: val.seriesAreaStartColor
              },
              {
                offset: 1,
                color: val.seriesAreaEndColor
              }
            ])
          }
        }]
      });
    },
    adaptationVars: function (val) {
      this.chart.setOption({
        tooltip: {
          borderWidth: val.tooltipBorderWidth,
          padding: val.tooltipPadding,
          textStyle: {
            fontSize: val.tooltipFontSize,
          },
          extraCssText: `border-radius: ${val.tooltipBorderRadius}px;`,
          axisPointer: {
            lineStyle: {
              width: val.tooltipAxisLineWidth
            }
          }
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              fontSize: val.axisLabelFontSize
            }
          }
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              width: val.yAxisSplitLineWidth
            }
          },
          axisLabel: {
            textStyle: {
              fontSize: val.axisLabelFontSize
            }
          }
        },
        series: [{
          symbolSize: val.seriesSymbolSize,
          lineStyle: {
            width: val.seriesLineWidth,
          }
        }]
      });
      this.resize();
    },
    '$store.state.home.chainCid'(newValue) {
      if (newValue) this.getData(newValue)
    }
  },
  mounted() {
    this.initChart()
    let cid = this.$store.state.home.chainCid
    if (cid) {
      this.getData(cid)
    }
    window.addEventListener('resize', this.resize, false)
  },
  methods: {
    initChart() {
      let container = document.getElementById('realChart')
      let chart = echarts.init(container)
      chart.setOption(this.option)
      this.chart = chart
    },
    resize() {
      this.chart.resize()
    },
    getData(cid) {
      this.$apis.home.getTxnLine({ chainId: cid }).then(res => {
        if (res.data) {
          let result = this.handleLine(res.data)
          this.chart.setOption({
            xAxis: {
              data: result[0].reverse()
            },
            series: [
              {
                data: result[1].reverse()
              }
            ]
          })
        }
      })
    },
    handleLine(data) {
      let hour = []
      let num = []
      data.map(ele => {
        let time = this.format(ele.Hourtime)
        hour.push(time)
        num.push(ele.Num)
      })
      return [hour, num]
    },
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    format(timeStamp) {
      let time = new Date(timeStamp * 1000)
      let m = time.getMonth() + 1
      let d = time.getDate()
      let h = time.getHours()
      let mm = time.getMinutes()
      let s = time.getSeconds()
      return this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm)
    }
  }
}
</script>
<style lang="scss" scoped>
.txn-wrap {
  width: 100%;
  height: 100%;

  .line-chart {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
